import mySuxApi from '../services/dataSources/mySuxApi';

// constants
import { config } from '../config';

export const setCollectionDate =
(orderIdx, selectedDate, cardId, groupId, pushQueue, queueMessage) =>
(dispatch, getState) => {
  const { userGuid, userId } = getState().user;
  const body = {
    cardId,
    orderIdx,
    userGuid,
    delSchedIdx: selectedDate.delSchedIdx,
    notes: '',
    collectionDate: selectedDate.delDate.format('YYYY-MM-DD'),
    groupId,
    Queue: !!parseInt(queueMessage, 10)
  };

  return mySuxApi.post(`${config.URLS.MY_SOFOLOGY_API}${userGuid}/BookDelivery/RequestCollectionDate/${cardId}/${userId}`, body)
    .then((res) => {
      return res;
    })
    .catch(e => console.error(e, `App failed to Book Collection: ${orderIdx} for ${cardId}`));
};


// WEBPACK FOOTER //
// ./src/actions/sofarescue.js